import React, { ReactNode } from 'react';
import AntdTooltip from 'antd/lib/tooltip';

/**
 * {@docCategory Tooltip}
 */
export type TooltipPlacement =
   | 'top'
   | 'left'
   | 'right'
   | 'bottom'
   | 'topLeft'
   | 'topRight'
   | 'bottomLeft'
   | 'bottomRight'
   | 'leftTop'
   | 'leftBottom'
   | 'rightTop'
   | 'rightBottom';

/**
 * {@docCategory Tooltip}
 */
export declare type TooltipRenderFunction = () => React.ReactNode;

/**
 * {@docCategory Tooltip}
 */
export interface TooltipProps {
   /**
    * Whether the arrow is pointed at the center of target
    */
   arrowPointAtCenter?: boolean;

   /**
    * Whether to adjust popup placement automatically when popup is off screen
    */
   autoAdjustOverflow?: boolean;

   backgroundColor?: string;

   /**
    * The position of the tooltip relative to the target
    */
   placement?: TooltipPlacement;

   /**
    * The text shown in the tooltip
    */
   title?: ReactNode | TooltipRenderFunction;

   /**
    * Tooltip trigger mode. Could be multiple by passing an array
    */
   trigger?: 'hover' | 'focus' | 'click' | 'contextMenu' | Array<string>;

   /**
    * Whether the floating tooltip card is visible or not
    */
   visible?: boolean;

   /**
    * Callback executed when visibility of the tooltip card is changed
    */
   onVisibleChange?: (visible: boolean) => void;

   /**
    * The DOM container of the tip, the default behavior is to create a div element in body
    * @param triggerNode - The HTMLElement the tip points at
    */
   getPopupContainer?: (triggerNode: HTMLElement) => HTMLElement;

   overlayClassName?: string;
}

export const Tooltip = (props: React.PropsWithChildren<TooltipProps>) => {
   const visibleProp = props.visible === undefined ? {} : {visible: props.visible}
   return (
      <AntdTooltip
         arrowPointAtCenter={props.arrowPointAtCenter}
         autoAdjustOverflow={props.autoAdjustOverflow}
         color={props.backgroundColor}
         placement={props.placement}
         title={props.title}
         trigger={props.trigger}
         onVisibleChange={props.onVisibleChange}
         getPopupContainer={props.getPopupContainer}
         overlayClassName={props.overlayClassName}
         {...visibleProp}
      >
         {props.children}
      </AntdTooltip>
   );
};
